<div class="custom-toggle-group">
  <div
    *ngFor="let option of options"
    class="custom-toggle-option"
    [class.selected]="option === currentOption"
    (click)="onOptionClick(option)"
  >
    {{ option }}
  </div>
</div>
